import { render, staticRenderFns } from "./AnswersRadio.vue?vue&type=template&id=8d93a30c"
import script from "./AnswersRadio.vue?vue&type=script&lang=js"
export * from "./AnswersRadio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports